<template>
  <span class="asd20-formatted-date">{{ prefix }}{{ formattedDate }}</span>
</template>

<script>
import format from 'date-fns/format'
export default {
  name: 'Asd20FormattedDate',
  props: {
    dateTime: { type: [String, Function], default: new Date().toISOString() },
    prefix: { type: String },
  },
  computed: {
    formattedDate() {
      // let apStyle = ['Jan.', 'Feb.', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.']
      // let shortMonths = /January|February|August|September|October|November|December /
      let formatted = format(new Date(this.dateTime), ' MMMM D, YYYY')
      // for (let month of apStyle) {
      //   if (formatted.includes(month)) {
      //     formatted = month
      //   } else formatted
      // }
      return formatted
    },
  },
}
</script>

<style lang="scss"></style>
